export default __webpack_public_path__ + "static/media/investmentBg.efbc845c.jpg";